import axios from 'axios';

export const EVENTS_SURVEYS_API_URL = process.env.VUE_APP_EVENTS_SURVEYS_API_URL;

export function fetchQuestionTypes(projectId) {
  return axios({
    url: `${EVENTS_SURVEYS_API_URL}/question-types/`,
    method: 'GET',
    params: {
      project_id: projectId,
    },
  }).then((response) => response.data);
}

export function fetchQuestionTypeById(typeId) {
  return axios({
    url: `${EVENTS_SURVEYS_API_URL}/question-types/${typeId}`,
    method: 'GET',
  }).then((response) => response.data);
}

export function saveQuestionType(questionType) {
  return axios({
    method: 'POST',
    url: `${EVENTS_SURVEYS_API_URL}/question-types/`,
    data: questionType,
  }).then((response) => response.data);
}

export function saveQuestions(questions) {
  return axios({
    method: 'POST',
    url: `${EVENTS_SURVEYS_API_URL}/questions/`,
    data: questions,
  }).then((response) => response.data);
}
